var ActionNames;

ActionNames = require('./ActionNames');

module.exports = {
  accountLoaded: function(account) {
    return {
      type: ActionNames.AccountLoaded,
      account: account
    };
  },
  galleryLoaded: function(gallery) {
    return {
      type: ActionNames.GalleryLoaded,
      gallery: gallery
    };
  },
  libraryLoaded: function(library) {
    return {
      type: ActionNames.LibraryLoaded,
      library: library
    };
  },
  libraryPhotoToggled: function(photoId) {
    return {
      type: ActionNames.LibraryPhotoToggled,
      photoId: photoId
    };
  },
  galleryDetailsUpdated: function(id, name) {
    return {
      type: ActionNames.GalleryDetailsUpdated,
      id: id,
      name: name
    };
  },
  editGalleryLoaded: function(gallery) {
    return {
      type: ActionNames.EditGalleryLoaded,
      id: gallery.id,
      name: gallery.name,
      photos: gallery.photos
    };
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvc3RhdGUvQWN0aW9uRmFjdG9yaWVzLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9hcHAvc3JjL3N0YXRlL0FjdGlvbkZhY3Rvcmllcy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxXQUFBLEdBQWMsT0FBQSxDQUFRLGVBQVI7O0FBRWQsTUFBTSxDQUFDLE9BQVAsR0FBaUI7RUFDaEIsYUFBQSxFQUFlLFNBQUMsT0FBRDtXQUFhO01BQzNCLElBQUEsRUFBTSxXQUFXLENBQUMsYUFEUztNQUUzQixTQUFBLE9BRjJCOztFQUFiLENBREM7RUFNaEIsYUFBQSxFQUFlLFNBQUMsT0FBRDtXQUFhO01BQzNCLElBQUEsRUFBTSxXQUFXLENBQUMsYUFEUztNQUUzQixTQUFBLE9BRjJCOztFQUFiLENBTkM7RUFXaEIsYUFBQSxFQUFlLFNBQUMsT0FBRDtXQUFhO01BQzNCLElBQUEsRUFBTSxXQUFXLENBQUMsYUFEUztNQUUzQixTQUFBLE9BRjJCOztFQUFiLENBWEM7RUFnQmhCLG1CQUFBLEVBQXFCLFNBQUMsT0FBRDtXQUFhO01BQ2pDLElBQUEsRUFBTSxXQUFXLENBQUMsbUJBRGU7TUFFakMsU0FBQSxPQUZpQzs7RUFBYixDQWhCTDtFQXFCaEIscUJBQUEsRUFBdUIsU0FBQyxFQUFELEVBQUssSUFBTDtXQUFjO01BQ3BDLElBQUEsRUFBTSxXQUFXLENBQUMscUJBRGtCO01BRXBDLElBQUEsRUFGb0M7TUFHcEMsTUFBQSxJQUhvQzs7RUFBZCxDQXJCUDtFQTJCaEIsaUJBQUEsRUFBbUIsU0FBQyxPQUFEO1dBQWE7TUFDL0IsSUFBQSxFQUFNLFdBQVcsQ0FBQyxpQkFEYTtNQUUvQixFQUFBLEVBQUksT0FBTyxDQUFDLEVBRm1CO01BRy9CLElBQUEsRUFBTSxPQUFPLENBQUMsSUFIaUI7TUFJL0IsTUFBQSxFQUFRLE9BQU8sQ0FBQyxNQUplOztFQUFiLENBM0JIIn0=
